import type { AcceptanceTimeItem } from '@/app/types/Dashboard';

export const Chart = {
	toAcceptanceTimeOptions: (data: AcceptanceTimeItem) => {
		const { averageTime: seconds } = data;
		const lowerLimit = 60 * 0.33;
		const midLimit = 60 * 0.66;

		let color = '';
		if (seconds <= lowerLimit) {
			color = '#18c096';
		} else if (seconds > lowerLimit && seconds <= midLimit) {
			color = '#ea6200';
		} else {
			color = '#ad012d';
		}

		return {
			credits: {
				enabled: false,
			},
			chart: {
				type: 'solidgauge',
				margin: [0, 0, 0, 0],
				height: 118,
				width: 238,

				//
				plotBackgroundColor: undefined,
				plotBorderWidth: 0,
				plotShadow: false,
			},
			accessibility: {
				point: {
					valueSuffix: '%',
				},
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			title: {
				text: `${seconds} sec`,
				align: 'center',
				verticalAlign: 'middle',
				y: 55,
				margin: 0,
				useHTML: true,
				style: {
					margin: '0px',
					color: `${color}`,
					fontFamily: 'Graphik-Semibold',
					fontSize: '16px',
					'background-color': '#f2f2f2',
					padding: '0px 25px',
					borderRadius: '32px',
					height: '32px',
					lineHeight: '32px',
				},
			},

			pane: {
				size: '203%',
				center: ['50%', '105%'],

				startAngle: -74,
				endAngle: 74,
				background: {
					borderWidth: 0,
					backgroundColor: '#f2f2f2',
					shape: 'arc',
					borderColor: 'transparent',
					outerRadius: '100%',
					innerRadius: '90%',
				},
			},

			// the value axis
			yAxis: {
				min: 0,
				max: 60,
				showFirstLabel: true,
				showLastLabel: true,
				stops: [[1, `${color}`]],

				lineWidth: 0,
				tickPositions: [0, 10, 20, 30, 40, 50, 60],
				minorTickWidth: 0,
				tickWidth: 4,
				tickLength: 14,
				tickColor: '#ffff',
				tickPosition: 'inside',
				zIndex: 6,

				labels: {
					enabled: true,
					formatter: (event: { isFirst: boolean; isLast: boolean }) => {
						if (event.isFirst) {
							return '0';
						}

						if (event.isLast) {
							return '60';
						}

						return '';
					},
					y: 20,
					distance: -5,
					useHTML: true,
					style: {
						color: '#9194a1',
						fontFamily: 'Graphik-Medium',
						fontSize: '12px',
					},
				},
			},

			plotOptions: {
				solidgauge: {
					animation: true,
					dataLabels: {
						enabled: false,
					},
				},
			},
			series: [
				{
					type: 'solidgauge',
					data: [
						{
							y: seconds,
							radius: 100,
							innerRadius: 90,
							title: null,
						},
					],
				},
			],
		};
	},
};
